import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'course',
    name: 'Course',
    component: () => import('@/views/course/index.vue'),
   
  }
]

export default routes
